import { Origin } from "@bitwarden/web-vault/app/models/types/general-types";
import { AccountView } from "@bitwarden/web-vault/app/models/view/account/account.view";
import type { FiskilConsentItem } from "@bitwarden/web-vault/app/services/syncing/fiskil/types/api.types";
import type { FiskilAccount } from "@bitwarden/web-vault/app/services/syncing/fiskil/types/account.types";

export type FiskilConsentAndAccountsContext = {
  consents: FiskilConsentItem[];
  accounts: FiskilAccount[];
};

/**
 * Pure predicate used by {@link AccountDetailsComponent.hasActiveFiskilConsentCoveringAccount}.
 */
export function hasActiveFiskilConsentCoveringAccount(
  isPremium: boolean,
  fiskilCtx: FiskilConsentAndAccountsContext | undefined,
  accountId: string | undefined,
  accountViews: AccountView[] | null | undefined,
): boolean {
  if (!isPremium) {
    return false;
  }
  if (fiskilCtx == null || !accountId || accountViews == null) {
    return false;
  }
  const account = accountViews.find((a) => a.id === accountId);
  if (!account || account.origin !== Origin.fiskil) {
    return false;
  }
  const fiskilAccountId = account.basiqAccountId;
  if (!fiskilAccountId) {
    return false;
  }
  const fiskilRow = fiskilCtx.accounts.find((a) => a.account_id === fiskilAccountId);
  const arrangementId = fiskilRow?.arrangement_id;
  if (arrangementId == null || arrangementId === "") {
    return false;
  }
  return fiskilCtx.consents.some(
    (c) =>
      c.active !== false &&
      c.arrangement_id != null &&
      String(c.arrangement_id) === String(arrangementId),
  );
}
